import { Link } from 'react-router-dom';
import { routes } from '@platform/core/lib/routes';
import type { IMdInlinesProps } from './IMdInlinesProps';
import { MD_COLOURS } from './mdColours';
import { mdHref } from './mdHref';
import { mdRecordTab } from './mdRecordTab';

/**
 * Рядкові елементи статті без HTML-вставок: жирний, курсив, код, колір {red|…}, виділення ==…==; посилання rec: — на сторінку запису
 * (акцент із пунктирним підкресленням; стаття — на «Читанні»), http(s) і mailto — у новій вкладці; небезпечні адреси показуються текстом.
 */
export function MdInlines({ nodes, ws }: IMdInlinesProps) {
  return (
    <>
      {(nodes ?? []).map((n, i) => {
        const inner = n.children ? <MdInlines nodes={n.children} ws={ws} /> : n.text;
        switch (n.kind) {
          case 'bold': return <strong key={i}>{inner}</strong>;
          case 'italic': return <em key={i}>{inner}</em>;
          case 'code': return <code key={i} className="md__code">{n.text}</code>;
          case 'mark': return <mark key={i} className="md__mark">{inner}</mark>;
          case 'colour': return <span key={i} className="md__colour" style={{ color: MD_COLOURS[n.colour ?? ''] }}>{inner}</span>;
          case 'link': {
            const h = mdHref(n.href ?? '');
            if (h?.kind === 'record') return <Link key={i} className="md__rec" to={routes.record(h.module, h.rt, h.id, mdRecordTab(h.module, h.rt))}>{inner}</Link>;
            if (h?.kind === 'external') return <a key={i} className="md__link" href={h.url} target="_blank" rel="noopener noreferrer">{inner}</a>;
            return <span key={i}>{inner}</span>;
          }
          default: return <span key={i}>{n.text}</span>;
        }
      })}
    </>
  );
}
